// libraries
import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";
import colors from "core/colors";

import ThankYouSpeechBubble from "./ThankYouSpeechBubble";

// styles
import {
    CreatorContainer,
    AvatarLink,
    CreatorAvatar,
    NameLink,
    CreatorName,
    CreatorCountry
} from "./styles";

const Creator = ({ className, creator }) => {
    const { username, avatarUrl, name, country } = creator;

    const creatorProfilePath = `/${encodeURIComponent(username)}/`;

    return (
        <CreatorContainer className={className}>
            <ThankYouSpeechBubble>
                <AvatarLink href={creatorProfilePath}>
                    <CreatorAvatar src={avatarUrl} alt={`${name} Avatar`} />
                </AvatarLink>
            </ThankYouSpeechBubble>

            <CreatorName type="div" size="xs">
                <NameLink href={creatorProfilePath}>{name}</NameLink>
            </CreatorName>

            {!!country && (
                <CreatorCountry>
                    <BodyText size="sm" copyColor={colors.primary.diamond}>
                        {country}
                    </BodyText>
                </CreatorCountry>
            )}
        </CreatorContainer>
    );
};

Creator.propTypes = {
    className: PropTypes.string,
    creator: PropTypes.object.isRequired
};

export default Creator;
